import { mdiAccountGroup } from '@mdi/js'

export default [
  {
    title: 'Menu.Coworkers',
    icon: mdiAccountGroup,
    resource: 'all',
    action: 'can_see_coworkers_menu',
    children: [
      {
        to: 'coworkers',
        title: 'Coworkers.Manager.Menu',
        resource: 'all',
        action: 'can_see_coworker_manager',
      },
      {
        to: 'installers',
        title: 'Coworkers.Installer.Menu',
        resource: 'all',
        action: 'can_see_coworker_installer',
      },
    ],
  },
]
